(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire46a9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire46a9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aMkwP", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $349ca6351f33c11f$export$6d71b655afe1638d);
const $349ca6351f33c11f$var$FETCH_TIMEOUT_MS = 8000;
const $349ca6351f33c11f$export$6d71b655afe1638d = (url)=>{
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), $349ca6351f33c11f$var$FETCH_TIMEOUT_MS);
    return fetch(url, {
        signal: controller.signal
    }).then((response)=>response.ok ? response.json() : null).catch(()=>null).finally(()=>clearTimeout(timeoutId));
};

});


var $aMkwP = parcelRequire("aMkwP");
const $3b833cd2f3b924ce$var$isProductFormElement = (element)=>!!element && "handleErrorMessage" in element;
const $3b833cd2f3b924ce$var$setSubmitButtonAvailable = (submitButton, isAvailable)=>{
    const addToCartLabel = submitButton.querySelector("span:not(.sold-out-message)");
    const soldOutLabel = submitButton.querySelector(".sold-out-message");
    submitButton.disabled = !isAvailable;
    submitButton.toggleAttribute("aria-disabled", !isAvailable);
    addToCartLabel?.classList.toggle("hidden", !isAvailable);
    soldOutLabel?.classList.toggle("hidden", isAvailable);
};
const $3b833cd2f3b924ce$var$checkVariantAvailability = async (select)=>{
    const quickAdd = select.closest(".quick-add");
    const submitButton = quickAdd?.querySelector("[data-quick-add-variant-submit]");
    if (!submitButton) return;
    const variantId = select.value;
    if (!variantId) {
        $3b833cd2f3b924ce$var$setSubmitButtonAvailable(submitButton, true);
        return;
    }
    const productForm = quickAdd?.querySelector("product-form") ?? null;
    if ($3b833cd2f3b924ce$var$isProductFormElement(productForm)) productForm.handleErrorMessage();
    const productUrl = select.dataset.productUrl;
    if (!productUrl) return;
    const url = `${productUrl}?variant=${encodeURIComponent(variantId)}&view=qfc-availability`;
    const availability = await (0, $aMkwP.fetchJson)(url);
    if (!availability) return;
    if (select.value !== variantId) return;
    $3b833cd2f3b924ce$var$setSubmitButtonAvailable(submitButton, availability.isVariantAvailable);
};
document.addEventListener("change", (event)=>{
    const target = event.target;
    if (!(target instanceof HTMLSelectElement) || !target.hasAttribute("data-quick-add-variant-select")) return;
    $3b833cd2f3b924ce$var$checkVariantAvailability(target);
});

})();
//# sourceMappingURL=quickAddVariantAvailability.js.map
